import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Menu, MenuItem, MenuItemLabel, MenuSeparator } from '@/components/gluestack/menu';
import { Icon, CheckIcon } from '@/components/gluestack/icon';
import { HugeIconsWrapper } from '~/components/ui/HugeIconsWrapper';
import {
  getHeaderMenuSelectorButtonIcon,
  HeaderMenuSelectorButtonTrigger,
  HeaderMenuSelectorHeaderTrigger,
  type IHeaderMenuSelectorProps,
} from '~/components/ui/HeaderMenuSelector.shared';
export type {
  HeaderMenuSelectorTriggerVariant,
  IHeaderMenuSelectorItem,
  IHeaderMenuSelectorProps,
} from '~/components/ui/HeaderMenuSelector.shared';
export { HeaderMenuSelectorTitle } from '~/components/ui/HeaderMenuSelector.shared';

export function HeaderMenuSelector<T extends string>({
  value,
  onChange,
  items,
  triggerLabel,
  triggerVariant = 'header',
}: IHeaderMenuSelectorProps<T>) {
  const buttonIcon = getHeaderMenuSelectorButtonIcon(value, items);

  return (
    <Menu
      placement="bottom left"
      crossOffset={-4}
      offset={8}
      trigger={({ ...triggerProps }) => (
        triggerVariant === 'button' ? (
          <HeaderMenuSelectorButtonTrigger
            triggerLabel={triggerLabel}
            icon={buttonIcon}
            triggerProps={triggerProps}
          />
        ) : (
          <TouchableOpacity activeOpacity={0.7} {...triggerProps}>
            <HeaderMenuSelectorHeaderTrigger triggerLabel={triggerLabel} />
          </TouchableOpacity>
        )
      )}>
      {items.map((item) => (
        <React.Fragment key={`headerMenuSelector-fragment-${item.value}`}>
          {item.separatorBefore && <MenuSeparator key={`headerMenuSelector-separator-${item.value}`} />}
          <MenuItem
            key={`headerMenuSelector-item-${item.value}`}
            textValue={item.label}
            onPress={() => onChange(item.value)}
            className="gap-3">
            {item.icon && (
              <HugeIconsWrapper
                icon={item.value === value && item.solidIcon ? item.solidIcon : item.icon}
                size={20}
                className="text-typography-800"
              />
            )}
            <MenuItemLabel>{item.label}</MenuItemLabel>
            {item.value === value && <Icon as={CheckIcon} size="sm" />}
          </MenuItem>
        </React.Fragment>
      ))}
    </Menu>
  );
}
